import { FC } from 'react'
import { useGetSettings } from '@pages/CoursesCatalog/tabs/CatalogCoursesTab/hooks/getPlatformSettings'
import cn from './index.module.css'
import { getPromoCodeDiscountString } from '@pages/CoursesCatalog/modals/CourseEnrollmentModal/utils/tariff'

interface ClassPriceViewProps {
  isFree?: boolean
  currentPrice: number
  startPrice?: number | null
  firstPrice?: number | null
  promoCode?: IPromoCodeDiscount | null
}

const ClassPriceView: FC<ClassPriceViewProps> = ({
  isFree,
  currentPrice,
  startPrice,
  firstPrice,
  promoCode,
}) => {
  const { checkSettings } = useGetSettings()
  const showOldPrice = checkSettings('catalog_showOldPrice')

  return (
    <div className={cn.priceContainer}>
      {isFree ? (
        <div className={cn.currentPrice}>Бесплатно</div>
      ) : (
        <>
          <div className={cn.promoContainer}>
            <div className={cn.currentPrice}>{firstPrice ??currentPrice}р</div>
            {promoCode && (
              <div className={cn.promoTitle}>
                {getPromoCodeDiscountString(promoCode)}
              </div>
            )}
          </div>
          {!firstPrice && showOldPrice && startPrice && (
            <div className={cn.oldPrice}>{startPrice}р</div>
          )}
        </>
      )}
    </div>
  )
}

export default ClassPriceView
